import { Button } from "components/atoms";
import { PublicPage } from "components/templates";
import { Trans, useTranslation } from "react-i18next";
import { PiConfetti } from "react-icons/pi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BUTTON_VARIANT } from "types/components/button/button.interface";

const RegisterConfirmation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const email = params.get("email") ?? "";

  const goToLogin = () => navigate(`/login?email=${email}`);

  return (
    <PublicPage
      header={
        <div className="flex gap-4  items-center">
          <PiConfetti size={50} />
          <p className="text-lg font-semibold">
            {t("confirm-email.creative.header")}
          </p>
        </div>
      }
    >
      <p className="text-center">
        <Trans
          i18nKey="register-confirmation.message"
          values={{ email: email }}
          components={{ strong: <strong /> }}
        />
      </p>
      <div />
      <div />
      <Button variant={BUTTON_VARIANT.submit} onClick={goToLogin}>
        <Button.Text text={t("register-confirmation.button")} />
      </Button>
    </PublicPage>
  );
};

export default RegisterConfirmation;
